var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconFriendsWave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 150 150"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M17.13 86.504a60 60 0 1 0 120 0 60 60 0 1 0-120 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m57.48 131.312-.117-1.276 6.707-.615a1.35 1.35 0 0 0 1.218-1.465l-.488-5.364a20.877 20.877 0 0 0-22.705-18.88c-.038 0-.073.011-.11.014l-12.069 1.11a15.07 15.07 0 0 1-9.6-2.387 1.65 1.65 0 0 0-2.001.15l-4.395 3.937a.827.827 0 0 0 .031 1.257 23.22 23.22 0 0 0 12.774 5.085 4.02 4.02 0 0 1 3.69 3.651l1.36 14.78"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m56.562 121.319.801 8.719M42.834 111.759l1.797 19.552"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M18.813 102.16a16 16 0 0 1-2.157-2.024L7.569 89.027a3.37 3.37 0 1 0-5.1 4.407l9.095 11.115a22 22 0 0 0 2.167 2.169ZM35.606 105.383a14.48 14.48 0 0 0 1.004 9.017 1.35 1.35 0 0 0 1.972.45l4.252-3.083 4.742 2.25a1.35 1.35 0 0 0 1.858-.796 14.5 14.5 0 0 0-.655-9.049 20.98 20.98 0 0 0-13.173 1.21"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m42.834 111.759-4.698-3.9a1.35 1.35 0 0 1-.48-.912l-.687-7.497 9.389-.863.688 7.493a1.35 1.35 0 0 1-.3.984Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m53.85 84.372-.309-3.354a13.47 13.47 0 0 0-26.826 2.465l.309 3.353a2.7 2.7 0 1 0 .492 5.366c.057 0 .108-.024.164-.031a13.452 13.452 0 0 0 26.497-2.437c.055 0 .11.008.165 0a2.7 2.7 0 1 0-.492-5.363Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M37.221 95.1a5.877 5.877 0 0 0 8.072-.75M47.931 86.268a2.195 2.195 0 0 0-4.035.37M37.212 87.252a2.195 2.195 0 0 0-4.035.37"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M31.559 92.013a1.683 1.683 0 1 0 3.366 0 1.683 1.683 0 1 0-3.366 0M46.983 90.596a1.683 1.683 0 1 0 3.366 0 1.683 1.683 0 1 0-3.366 0"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M40.268 68.781a14 14 0 0 0-1.379.057 13.455 13.455 0 0 0-12.18 14.645l.309 3.354a2.32 2.32 0 0 1 2.356 2.1 12.2 12.2 0 0 0-.216-5.48c1.458.342 3.6-1.887 3.6-1.887l-.3-3.219a32.2 32.2 0 0 0 7.391.945 32.2 32.2 0 0 0 7.101-2.271l.3 3.219s2.51 1.8 3.88 1.2a12.2 12.2 0 0 0 .786 5.426 2.32 2.32 0 0 1 1.936-2.498l-.31-3.354a13.47 13.47 0 0 0-13.275-12.237"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m31.66 65.444 13.718-1.26a4.04 4.04 0 0 1 4.208 2.758l4.62 14.015-28.167 2.593 1.989-14.622a4.04 4.04 0 0 1 3.633-3.484"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20.796 85.379a1.35 1.35 0 1 1-.246-2.683l38.898-3.574a1.35 1.35 0 0 1 .246 2.684Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m113.046 131.312 2.282-20.495-10.71-1.183-2.414 21.677M141.216 86.14l-.6 1.34 6.774 3 .6-1.333a3.711 3.711 0 1 0-6.772-3Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m102.204 131.312 2.414-21.679a15.2 15.2 0 0 1-2.768-5.383 20.85 20.85 0 0 0-14.163 17.477l-1.066 9.59"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m95.429 131.312 1.48-13.309"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M101.85 104.237a21 21 0 0 1 4.154-.927l.358-3.229a16.58 16.58 0 0 0-10.8 2.414 1.34 1.34 0 0 0-.394 1.85l4.783 7.513a1.35 1.35 0 0 0 2.069.249l2.593-2.485a15.2 15.2 0 0 1-2.763-5.385"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m119.823 131.312 1.182-10.627a8.9 8.9 0 0 1 6.422-7.576 28.3 28.3 0 0 0 18.202-15.867l2.13-4.825a1.65 1.65 0 0 0-.843-2.176l-5.608-2.474a1.65 1.65 0 0 0-2.175.843l-2.13 4.822a18.99 18.99 0 0 1-21.633 10.922 21 21 0 0 1 3.844 1.824 15.2 15.2 0 0 1-3.887 4.639l-2.281 20.495"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M119.217 106.17a21 21 0 0 0-3.848-1.816l.359-3.23a16.57 16.57 0 0 1 10.007 4.731 1.34 1.34 0 0 1-.022 1.89l-6.313 6.279a1.35 1.35 0 0 1-2.073-.213l-1.986-3h0a15.3 15.3 0 0 0 3.876-4.641"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M104.607 109.622a15.2 15.2 0 0 1-2.761-5.386 21 21 0 0 1 4.153-.927l.3-2.734a13.5 13.5 0 0 0 9.403 1.035h-.031l-.3 2.748a21 21 0 0 1 3.848 1.816 15.3 15.3 0 0 1-3.881 4.643v.009a9.17 9.17 0 0 1-5.616 1.716 9.17 9.17 0 0 1-5.1-2.904"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m126.15 86.7.372-3.347a13.47 13.47 0 1 0-26.772-2.981l-.372 3.346a2.7 2.7 0 0 0-.6 5.355h.167a13.452 13.452 0 0 0 26.446 2.943c.054.01.105.028.16.035a2.7 2.7 0 1 0 .6-5.356Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M119.97 87.366a2.193 2.193 0 0 0-4.026-.45M109.274 86.175a2.196 2.196 0 0 0-4.03-.45"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M104.198 92.085a1.683 1.497 6.351 1 0 .331-2.975 1.683 1.497 6.351 1 0-.331 2.975M119.593 93.8a1.683 1.497 6.351 1 0 .331-2.975 1.683 1.497 6.351 1 0-.331 2.975"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M107.7 94.131a5.86 5.86 0 0 0 8.032.9"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M126.107 72.786a2.6 2.6 0 0 0 .337-.963c.576-5.175-2.827-9.801-9.666-10.563-1.34-.15-8.11.254-6.248-4.761-8.4 2.453-8.85 12.567-8.85 12.567a2.9 2.9 0 0 0 .28 1.434c-1.82 1.337-5.284 5.024-2.513 12.549a14.88 14.88 0 0 0 5.06-8.925l-.3-.804a17.52 17.52 0 0 0 18.434 2.297c-.504 5.3 3.576 10.411 3.576 10.411 4.825-7.45 1.169-11.99-.11-13.242"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M91.974 140.67v-13.731h6.929a3.464 3.464 0 0 0 3.463-3.463 26.85 26.85 0 0 0-53.7 0 3.465 3.465 0 0 0 3.465 3.463h6.929v13.731"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M69.45 100.016v-4.95c-4.614 1.657-7.8 5.06-7.8 8.483 0 3.183 2.746 7.142 6.838 9.042a1.76 1.76 0 0 0 2.021-.362l4.998-5.215-3.874-2.764a5.2 5.2 0 0 1-2.183-4.234M81.58 95.072v4.95a5.2 5.2 0 0 1-2.174 4.228l-3.887 2.777 4.998 5.213a1.76 1.76 0 0 0 2.02.364c4.093-1.901 6.839-5.86 6.839-9.043 0-3.429-3.18-6.832-7.796-8.49"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m79.405 104.25-3.886 2.777-3.886-2.777a5.2 5.2 0 0 1-2.183-4.234V91.43h12.124v8.585a5.2 5.2 0 0 1-2.169 4.234M100.634 140.67v-9.4h-8.66v9.4M59.064 140.67v-9.4h-8.661v9.4"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M91.974 120.878v6.061M59.064 120.878v6.061"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M100.634 126.474a3.43 3.43 0 0 1-1.732.465h-6.928v4.33h8.66ZM59.064 126.939h-6.929a3.45 3.45 0 0 1-1.732-.465v4.8h8.661ZM100.634 93.164V78.44a16.43 16.43 0 0 0-6.316-12.961 23 23 0 0 1 .254 3.434v2.599a1.733 1.733 0 0 1-1.732 1.732 3.465 3.465 0 1 1 0 6.929c-.073 0-.142-.019-.214-.023a17.32 17.32 0 0 1-6.15 10.827 19.07 19.07 0 0 0 13.274 9.662 1.739 1.739 0 0 0 1.92-2.4 13 13 0 0 1-1.037-5.076"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M92.84 73.245v-4.33a17.322 17.322 0 0 0-34.643 0v4.33a3.465 3.465 0 0 0 0 6.929c.074 0 .141-.019.213-.023a17.298 17.298 0 0 0 34.217 0c.071 0 .14.023.212.023a3.465 3.465 0 1 0 0-6.929"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M63.394 80.606a2.165 2.165 0 1 0 4.33 0 2.165 2.165 0 1 0-4.33 0M83.313 80.606a2.165 2.165 0 1 0 4.329 0 2.165 2.165 0 1 0-4.329 0"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M70.308 85.004a7.556 7.556 0 0 0 10.422 0M85.059 74.976a2.822 2.822 0 0 0-5.21 0M71.189 74.976a2.823 2.823 0 0 0-5.211 0"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M75.519 48.994c-10.394 0-15.519 6.311-18.051 13.856h-1.869a1.733 1.733 0 0 0-1.731 1.732 6.29 6.29 0 0 0 2.598 5.31v1.619a1.733 1.733 0 0 0 1.734 1.734 1.86 1.86 0 0 0 1.843-1.624l.036-.276a10.3 10.3 0 0 0 2.02.168A7.36 7.36 0 0 0 69.45 64.2v-.255a4.767 4.767 0 0 1 4.764-4.556h3.036a13.86 13.86 0 0 1 13.763 12.23 1.84 1.84 0 0 0 1.826 1.628 1.733 1.733 0 0 0 1.733-1.733v-2.6c0-10.522-7-19.92-19.053-19.92"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M61.21 61.818a.174.174 0 0 0 .287.188 19.227 19.227 0 0 1 27.561-.518.284.284 0 0 0 .45-.327 15.609 15.609 0 0 0-28.3.657Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M69.45 64.2a7.36 7.36 0 0 1-7.35 7.312h0c-4.545 0-8.228-2.385-8.228-6.928A1.733 1.733 0 0 1 55.6 62.85h1.869c2.462 0 3.858.021 5.927-2.598"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M114.825 3.531A31.548 31.548 0 0 0 98.492 61.05a23.75 23.75 0 0 1-6.869 12.047 1.06 1.06 0 0 0 .801 1.82c10.388-.613 16.5-4.05 20.586-8.497a31.554 31.554 0 1 0 1.815-62.895Z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m129.812 29.1-.133 3.423L117.9 20.73a2.723 2.723 0 0 0-3.612-.288 2.62 2.62 0 0 0-.201 3.888l-1.668-1.67a2.903 2.903 0 0 0-3.957-.214 2.795 2.795 0 0 0-.108 4.05l-.075-.075a2.66 2.66 0 0 0-3.192-.482 2.627 2.627 0 0 0-.564 4.14l3.126 3.125a2.3 2.3 0 0 0-3.408.176 2.39 2.39 0 0 0 .252 3.164L117.727 49.8a9.863 9.863 0 0 0 14.037-.063 15.22 15.22 0 0 0 4.253-11.355l-.403-12.688a1.133 1.133 0 0 0-1.135-1.097h0a4.69 4.69 0 0 0-4.668 4.503"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m107.642 33.21 6.356 6.357M108.346 26.489l9.357 9.358M114.08 24.33l7.578 7.578M129.68 32.517l-3.75 3.75a6.3 6.3 0 0 0 0 8.91h0M120.764 17.187a9.43 9.43 0 0 1 4.525 2.063 10.17 10.17 0 0 1 2.835 4.2M123.58 12.591a11.64 11.64 0 0 1 5.588 2.55 12.53 12.53 0 0 1 3.501 5.178M99.23 34.65a9.4 9.4 0 0 0 .832 4.904 10.15 10.15 0 0 0 3.326 3.816M93.764 36.063a11.63 11.63 0 0 0 1.027 6.054 12.54 12.54 0 0 0 4.107 4.712"
})));
export default SvgStreamlineIconFriendsWave;